<template>
    <CatchList />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CatchList from './CatchList.vue';
import { Bus, Stops } from '../../common/bus';

export default {
    components: { CatchList },
    created() {
        Bus.$emit(Stops.TITLE_CHANGED, `${this.country.name}`);
        this.loadCatchesFromFilter({ region: this.country, records: false });
    },
    computed: {
        ...mapState('session', ['country']),
    },
    methods: {
        ...mapActions('catches', ['loadCatchesFromFilter']),
    },
};
</script>

<style lang="scss" scoped></style>
